import { notificationsProtectedAxios } from '@/lib/axiosInstance';
import {
  NotificationsListingRequest,
  NotificationsListingResponse,
  UnreadCountResponse,
} from '@/types/api/notification';

export const getNotifications = async (
  payload: NotificationsListingRequest
): Promise<NotificationsListingResponse> => {
  const response = await notificationsProtectedAxios.get('/my', {
    params: payload,
  });
  return response.data;
};

export const getUnreadCount = async (): Promise<UnreadCountResponse> => {
  const response = await notificationsProtectedAxios.get('/unread-count');
  return response.data;
};

export const changeReadStatus = async (payload: {
  notificationId: string;
  read: boolean;
}): Promise<void> => {
  const response = await notificationsProtectedAxios.post(
    `/${payload.notificationId}/read`,
    { read: payload.read }
  );
  return response.data;
};
